
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Navbar = () => {
  const scrollToSubscribeForm = () => {
    document.getElementById('waitlist-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/50 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-2 md:py-4 flex justify-between items-center">
        <div>
          <h2 className="text-white font-bold text-lg md:text-xl">GridBot & DeFi Mastery</h2>
        </div>
        
        <div className="flex items-center space-x-2 md:space-x-4">
          <span className="hidden sm:inline text-white opacity-50 cursor-not-allowed text-sm md:text-base">Home</span>
          <span className="hidden sm:inline text-white opacity-50 cursor-not-allowed text-sm md:text-base">About</span>
          <Link to="/webinar" className="hidden sm:inline text-white hover:text-gray-300 text-sm md:text-base">
            Webinar
          </Link>
          <div className="flex items-center space-x-2 md:space-x-3">
            <span className="hidden md:inline text-white opacity-50 cursor-not-allowed">Sign in</span>
            <Button 
              onClick={scrollToSubscribeForm}
              className="bg-white text-black hover:bg-gray-200 text-sm md:text-base px-3 py-2 md:px-4"
            >
              Subscribe
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
